import BHowRegister from './BHowRegister'

export default BHowRegister
